import { AVAILABLE_LANGUAGES } from "@/i18n/languages";
import { LocalStorageConstants } from "@/types/LocalStorageConstants";
import { useLocalStorage } from "./useLocalStorage";

export function useLanguage() {
  const [language, setLanguage] = useLocalStorage<string>(LocalStorageConstants.LANGUAGE, AVAILABLE_LANGUAGES[0].locale);

  function setLanguageWithValidation(newLanguage: string) {
    const isValidLanguage = AVAILABLE_LANGUAGES.some((lang) => lang.locale === newLanguage);

    if (isValidLanguage) {
      setLanguage(newLanguage);
    } else {
      console.warn(`Invalid language: ${newLanguage}. Setting to default.`);
      setLanguage(AVAILABLE_LANGUAGES[0].locale);
    }
  }

  return {
    language,
    setLanguage: setLanguageWithValidation,
  };
}
